// @module Tavano.TTPDPLeadTime.TTPDPLeadTime
define("Tavano.TTPDPLeadTime.TTPDPLeadTime.View",
  [
    "tavano_ttpdpleadtime_ttpdpleadtime.tpl",
    "TavanoTeam.TTPDPLeadTime.Request.View",
    "Backbone"
  ],
  function (
    tavano_ttpdpleadtime_ttpdpleadtime_tpl,
    RequestView,
    Backbone
  ) {
    "use strict";

    // @class Tavano.TTPDPLeadTime.TTPDPLeadTime.View @extends Backbone.View
    return Backbone.View.extend({
      template: tavano_ttpdpleadtime_ttpdpleadtime_tpl,

      initialize: function (options) {
        this.itemInfo = options.pdp.getItemInfo();
        this.cart = options.cart;
        this.container = options.container;
        this.environment = this.container.getComponent("Environment");

        this.layout = this.container.getComponent("Layout");
        this.application = this.layout.application;
        this.getLayout = this.application.getLayout();
      },

      events: {
        'click [data-action="request-lead-time"]': "requestLeadTime"
      },

      bindings: {},

      childViews: {},

      requestLeadTime: function requestLeadTime() {
        var layout = this.options.container.getLayout();
        var view = new RequestView(this.itemInfo);
        layout.showInModal(view);
      },
      //@method getContext @return Tavano.TTPDPLeadTime.TTPDPLeadTime.View.Context
      getContext: function getContext() {
        //@class Tavano.TTPDPLeadTime.TTPDPLeadTime.View.Context
        this.message = "To request the lead time of this item please click here";
        this.buttonText = "Lead Times";
        return {
          message: this.message,
          buttonText: this.buttonText
        };
      }
    });
  });
